import React from 'react';
import Chip from '@mui/material/Chip';
import { ucFirst } from "../../helpers/string_helper";

const statusBadge = (props) => {
    return(

        // This is the static bagde color
        // <Chip label={ucFirst(props.label)} style={{ background: '#EBEDF5', color: '#2B2F3E',borderRadius: '0px'}} />


        <Chip className="small_status_chip" label={ucFirst(props.label)} style={{ background: props.background ? props.background : props.color ? props.color + '33' : '#bababa', color: props.color ? props.color : '#ffffff'}} />

    )
}

export default statusBadge;